import React,{useRef} from 'react';
import { Modal, Table } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { useDispatch, useSelector } from "react-redux";
import { setCustomerFaultsPop, loadFaultsByCustomer } from '../../store/api/Services';
import Loader from 'react-loader-spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
const ModalSelectFaultByCustomer = () => {
    const customerFaultsPopStatus = useSelector(state => state.service.customerFaultsPopStatus);
    const faultsByCustomer = useSelector(state => state.service.faultsByCustomer);
    const desc = useRef('');
    const dispatch = useDispatch();
    const search = () => {
        dispatch(loadFaultsByCustomer(desc.current));
    }
    const select = (item) => {
        if (customerFaultsPopStatus.setData) {
            customerFaultsPopStatus.setData(item);
        }
        dispatch(setCustomerFaultsPop({ status: 'hide' }));
    }
    return (
        <Modal show={customerFaultsPopStatus.status === 'show'} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>اظهارات پیش فرض<FontAwesomeIcon icon={faTimes} size='lg' onClick={() => dispatch(setCustomerFaultsPop({ status: 'hide' }))}/></Modal.Header>
            <Modal.Body className='bodyStyle'>
                <div className="row">
                    <div className="form-group">
                        <input type="text" id="ItemDescForSeach" placeholder="نام" className="form-control" onChange={e=> desc.current = e.target.value} />
                    </div>
                </div>
                <button type="button" className="btn btn-primary w-100 mt-2" onClick={search}>جستجو</button>
                <br />
                <br />
                <Table responsive>
                    <thead>
                        <tr>
                            <th style={{ width: "30px" }}></th>
                            <th>شـــرح</th>
                        </tr>
                    </thead>
                    <tbody>
                        {faultsByCustomer === "PENDING" &&
                            <tr><td style={{ textAlign: "center" }} colSpan={2}> <Loader type="BallTriangle" color="#bb1370" height={30} width={30} /></td></tr>}
                        {faultsByCustomer && Array.isArray(faultsByCustomer) &&

                            faultsByCustomer.map((item, i) => {
                                return <tr className="resultTableRow" key={i} onClick={() => select(item)}>
                                    <td style={{ width: "30px" }}>{i + 1}</td>
                                    <td>{item}</td>
                                </tr>
                            })}
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectFaultByCustomer;